export { type MorphemeSearchVisit, morphemeSearchVisitTable } from "#morpheme-search-visit-table";
